module.exports = __webpack_public_path__ + "static/media/7.0c5b9d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/7.png
// module id = 1328
// module chunks = 0